<template>
  <div class="box10">
    <div class="titleContent">
      优势四
      <p>教研强</p>
    </div>
    <pageTitle
      title="专职课程研发团队 严控课程质量"
      text="高学历、实力派教研团队，学习效果更有保障"
      titleColor="#24375C"
      titColor="#86909C"
    />

    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        :style="
          `backgroundImage: url(` +
          require(`../../../assets/coursePage/dataAnalysis/box10/${
            index + 1
          }.png`) +
          `)`
        "
        @click="changeCur(index)"
      >
        <div class="tName">{{ item.name }}</div>
        <p v-html="item.p"></p>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in list[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in list[cur].info"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "原老师",
          tag: ["北京大学计算机硕士", "擅长人工智能、大数据领域技术"],
          p: "北京大学计算机硕士 | 擅长人工智能、大数据领域技术",
          info: [
            "曾在多家软件公司担任软件工程师、项目经理等职位；",
            "对数据分析、大数据、机器学习等技术有深入研究；",
            "多年项目开发经验，有新浪微博、中新网新闻发布系统等多个大型项目经验。",
          ],
        },
        {
          name: "王老师",
          p: "山东大学计算机硕士 | 10年开发经验",
          tag: ["山东大学计算机硕士", "10年开发经验"],
          info: [
            "具有10年项目开发与项目管理经验；",
            "主持开发过的项目涉及银行、政府等多领域；",
            "多年企业内训培训师，讲课深入浅出，深受学生和企业员工的好评。",
          ],
        },
        {
          name: "李老师",
          p: "计算机硕士 | 对大数据挖掘领域技术深有研究",
          tag: ["计算机硕士", "对大数据挖掘领域技术深有研究"],
          info: [
            "具有丰富的机器学习、深度学习等项目实施经验；",
            "曾主持并参与了多家互联网企业基于海量数据的用户画像、推荐系统及人脸支付相关项目；",
            "授课认真有激情、思路清晰、通俗易懂，深受学员喜爱。",
          ],
        },
        {
          name: "赵老师",
          p: "主导研发多项国家级科研项目 | 前美团数据工程师",
          tag: ["主导研发多项国家级科研项目", "前美团数据工程师"],
          info: [
            "多年数据挖掘开发经验；",
            "曾主导研发多项国家和省级科研项目，负责企业级信贷风控模型和智能医疗数据平台开发；",
            "曾任职美团搜索部，负责NER及Bert搜索排序优化。",
          ],
        },
        
      ],
    };
  },
  methods: {
    changeCur(index) {
      // if (index == 3) return;
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 60px 32px 58px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box10/bgc.png")
    no-repeat;
  background-size: cover;
  .titleContent {
    margin: 0 auto 60px;
    width: 360px;
    height: 80px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 4px 20px 0px rgba(202, 211, 235, 0.3),
      inset 2px 2px 2px 0px #ffffff;
    border-radius: 48px;
    backdrop-filter: blur(16px);
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    display: flex;
    padding: 0 8px 0 48px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    p {
      width: 176px;
      height: 64px;
      background: linear-gradient(270deg, #8192ff 0%, #a2aeff 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
    }
  }
  .word {
    white-space: nowrap;
  }

  .teacher-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 48px auto 0;

    .teacher {
      margin-bottom: 30px;
      padding-left: 24px;
      width: 328px;
      height: 424px;
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      .tName {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        margin-top: 276px;
      }
      p {
        margin-top: 4px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin: 8px 16px 0 0px;
      }
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;

    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
